module.exports = __webpack_public_path__ + "img/crown.ee5eec90.svg";